import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IUserInfoModel } from '.';
import { AppSettingsService } from './app-settings.service';
import { HttpService } from './http.service';
import { shareReplay } from 'rxjs/operators';

@Injectable()
export class UserContextService {
  private userInfoDictionary: { [userInfoId: string]: Observable<IUserInfoModel> } = {};

  private anonymousUserSub: Observable<IUserInfoModel>;

  constructor(private appSettings: AppSettingsService, private http: HttpService) {}

  public getUserInfo = (userInfoId: string, refreshCache = false): Observable<IUserInfoModel> => {
    // XTODO: implement directory?
    return this.http.get(`${this.appSettings.userInfoServiceUrl}${userInfoId}`);
  };

  public getUserInfoList = (userInfoIds: string[]): Observable<IUserInfoModel[]> => {
    if (!userInfoIds || userInfoIds.length === 0) {
      return of([]);
    }
    return this.http.get(`${this.appSettings.userInfoServiceUrl}search?includePublicIds=${userInfoIds}`);

    // const deferredResult = this.$q.defer<IUserInfoModel[]>();

    // const userInfoList: IUserInfoModel[] = [];

    // let usersProcessed = 0;
    // const userProcessed = () => {
    //     // If all users have finished processing, resolve the outer promise
    //     if (++usersProcessed === userInfoIds.length) {
    //         deferredResult.resolve(userInfoList);
    //     }
    // };

    // // Callbacks for individual user info resolved/rejected
    // const userInfoResolvedCallback = (userInfo: IUserInfoModel) => {
    //     userInfoList.push(userInfo);
    //     userProcessed();
    // };

    // const userInfoErrorCallback = (error: hd.IError) => {
    //     this.$log.error(error);
    //     userProcessed();
    // };

    // // Don't bother querying for any users that already exist from the list
    // const queryList: string[] = [];
    // const deferredPromises: { [id: string]: ng.IDeferred<IUserInfoModel> } = {};
    // for (const id of userInfoIds) {
    //     let userInfoPromise = this.userInfoDictionary[id];
    //     if (!userInfoPromise) {
    //         // User is not in our cache yet, so we want to query it and put a promise
    //         // for the individual user info object into our cache
    //         queryList.push(id);
    //         deferredPromises[id] = this.$q.defer<IUserInfoModel>();
    //         userInfoPromise = deferredPromises[id].promise;
    //         this.userInfoDictionary[id] = userInfoPromise;
    //     }

    //     userInfoPromise.then(userInfoResolvedCallback).catch(userInfoErrorCallback);
    // }

    // if (queryList.length > 0) {
    //     // Query users we haven't cached yet from server
    //     const params = { includePublicIds: queryList.toString() };

    //     this.userInfoService.getUserInfoSearchResource().query(params,
    //         (results: IUserInfoModel[]) => {
    //             // Resolve deferred promises for individual user info objects
    //             for (const userInfo of results) {
    //                 const userInfoDeferred = deferredPromises[userInfo.userInfoPublicId];
    //                 if (userInfoDeferred) {
    //                     userInfoDeferred.resolve(userInfo);
    //                     delete deferredPromises[userInfo.userInfoPublicId];
    //                 }
    //             }

    //             // Reject promises for any ids that did not come back in results (i.e. not found)
    //             for (const id in deferredPromises) {
    //                 if (deferredPromises.hasOwnProperty(id)) {
    //                     deferredPromises[id].reject('User not found: ' + id);
    //                 }
    //             }
    //         },
    //         (error: hd.IError) => {
    //             this.$log.debug('Failed to query user list');
    //             this.$log.error(error);
    //             deferredResult.reject(error);
    //         });
    // }

    // return deferredResult.promise;
  };

  public getAnonymousUser = (): Observable<IUserInfoModel> => {
    if (!this.anonymousUserSub) {
      this.anonymousUserSub = this.http.get<IUserInfoModel>(this.appSettings.userInfoServiceUrl + 'anonymous').pipe(shareReplay(1));
    }
    return this.anonymousUserSub;
  }
}
